
import storage from 'store2'
import {requestHttpGet,requestHttpPostByOnline,requestHttpUpload} from '@/api/main'
import apiUrl from '@/utils/config'
import { message } from 'ant-design-vue'
let disp = require("@/utils/broadcast");
let lastTextSendKey = ''
let lastTextSendAt = 0
// 断线重连：退避计数与调度定时器。
// 注意：主动关闭标志必须挂在 WebSocket 实例上(__manualClosed)，不能用全局变量——
// close() 是异步生效的，同步设置再复位的全局标志罩不住稍后到达的 onclose，
// 会把主动关闭误判为意外断开而无限重连(每次重连还触发会话刷新 HTTP)，曾导致服务器被请求风暴堵死
let reconnectAttempt = 0
let reconnectTimeout = null
// 连接活性看门狗：半开连接(NAT超时/休眠唤醒后 TCP 已死但收不到 RST)下心跳写入黑洞不报错、
// onclose 永不触发，表现为"收不到最新消息、退出重进才能看到"。记录最后收到服务端帧的时间，
// 超时未收到任何帧(含心跳响应)即主动断开，走既有 onclose 重连。
const SERVER_FRAME_TIMEOUT_MS = 90 * 1000
let lastServerFrameAt = 0
let watchdogTimer = null
// const link = "ws://127.0.0.1:48080/ws"
const link = "wss://commonapi.binliyoujia.com/ws"
const heartbeatInterval = 30000;
export default  {
  heartbeatTimeout:{},
  restIm:{},
  im:{},
  isReconnectedSession:false,
  //初始化
  initIm:function(vuedom){
    const that = this
    if('WebSocket' in window){
      // 防多连接：旧连接先标记自身"主动关闭"再关闭。
      // 标志挂在实例上，旧连接的 onclose 异步到达时读取的仍是 true，不会误触发重连；
      // 且 onclose 里还校验"是否仍是当前连接"(that.im !== im 的旧连接一律不重连)
      const old = that.im
      if(old && (old.readyState === 0 || old.readyState === 1)){
        old.__manualClosed = true
        try { old.close() } catch (e) { /* 忽略关闭异常 */ }
      }
      const im = new WebSocket(link)
      that.im = im
      im.onopen = ()=>{
        console.log("im已连接")
        // 记录本次连接是否为断线重连(首连时 reconnectAttempt=0)，供认证成功后通知页面补拉数据
        that.isReconnectedSession = reconnectAttempt > 0
        reconnectAttempt = 0
        lastServerFrameAt = Date.now()
        that.startWatchdog(vuedom)
        storage.set('isOnline',true)
        that.loginIm(storage.get('token'))
      }
      im.onclose = (e)=>{
        console.log("im已断开",e)
        storage.set('isOnline',false)
        clearTimeout(that.heartbeatTimeout);
        that.stopWatchdog()
        // 两种情况不重连：①本连接被主动关闭(closeIm/被新连接替换) ②本连接已不是当前连接
        // 意外断开(服务端读超时/网络波动/看门狗判定假死)才自动重连，否则消息收不到推送
        if(im.__manualClosed || that.im !== im){
          return
        }
        that.scheduleReconnect(vuedom)
      }
      im.onerror = ()=>{
        console.log("链接失败")
        clearTimeout(that.heartbeatTimeout);
        that.stopWatchdog()
        if(im.__manualClosed || that.im !== im){
          return
        }
        // onerror 后通常紧跟 onclose，由 onclose 统一调度重连；此处兜底 onclose 未触发的场景
        if(im.readyState != 0){
          that.scheduleReconnect(vuedom)
        }
      }
      im.onmessage= (e)=>{
        // 任何服务端帧(含心跳响应)都视为连接存活的证据，喂给看门狗
        lastServerFrameAt = Date.now()
        console.log("收到消息")
        console.log(e)
        let message = JSON.parse(e.data)
        // 0 - 2 认证消息
        if(message.code == 0 || message.code == 1 || message.code == 2){
          if(message.code == 0){
            storage.set('isOnline',true)
            // 重连成功：通知页面刷新会话列表、补拉当前会话最新消息
            // (断线期间服务端的推送不会补发，必须主动拉)
            if(that.isReconnectedSession){
              that.isReconnectedSession = false
              vuedom.$bus.$emit("im.reconnected",vuedom)
            }
          }
          if(message.code == 2){
            storage.set('isOnline',false)
          }
          vuedom.$bus.$emit("im.auth",message,vuedom);
        }else{
          //发送到消息总线
          vuedom.$bus.$emit("im.all",message,vuedom);
        }
        that.heartbeat()
      }
    }
  },
  //断线重连调度：指数退避(1s 起、30s 封顶)，避免服务端不可用时的重连风暴；多次触发只保留一个定时器
  scheduleReconnect:function(vuedom){
    const that = this
    if(reconnectTimeout != null){
      return
    }
    // 当前连接仍然存活时不需要重连(防御意外调度造成的循环)
    if(that.im && that.im.readyState === 1){
      return
    }
    const delay = Math.min(1000 * Math.pow(2,reconnectAttempt),30000)
    reconnectAttempt++
    console.warn("IM 断线，"+(delay/1000)+"s 后自动重连(第 "+reconnectAttempt+" 次)")
    reconnectTimeout = setTimeout(function(){
      reconnectTimeout = null
      that.initIm(vuedom)
    },delay)
  },
  isImConnected() {
    return !!(this.im && this.im.readyState === WebSocket.OPEN)
  },
  //连接活性看门狗：周期检查距上次收到服务端帧的时长，超过阈值判定假死连接，
  //主动断开(不标记 manualClosed，让 onclose 走意外断开重连)。半开连接下心跳只发
  //进黑洞不报错、onclose 永不触发，必须靠收帧时间判定
  startWatchdog(vuedom){
    const that = this
    this.stopWatchdog()
    watchdogTimer = setInterval(function(){
      const im = that.im
      if (!im || im.readyState !== 1){
        return //非 open 状态交给重连调度
      }
      if (Date.now() - lastServerFrameAt > SERVER_FRAME_TIMEOUT_MS){
        console.warn("IM 看门狗："+(SERVER_FRAME_TIMEOUT_MS/1000)+"s 未收到服务端帧，判定连接假死，主动断开重连")
        try { im.close() } catch (e) { /* 忽略关闭异常 */ }
        that.scheduleReconnect(vuedom)
      }
    },15000)
  },
  stopWatchdog(){
    if(watchdogTimer != null){
      clearInterval(watchdogTimer)
      watchdogTimer = null
    }
  },
  normalizeSessionItem(item) {
    if (item == null) return item
    if (item.unRead == null || item.unRead === undefined || Number.isNaN(item.unRead)) {
      const count = item.unReadCount != null ? item.unReadCount : item.unread_num
      item.unRead = count != null ? Number(count) : 0
    } else {
      item.unRead = Number(item.unRead) || 0
    }
    return item
  },
  //发送消息
  sendMessage(message) {
    if (this.isImConnected()) {
      console.log(message)
      this.im.send(JSON.stringify(message));
      //离线厂商推送已移到服务端(netty-im 按 WS 在线状态补推)：
      //前端不再触发，否则前端全量推+服务端离线推会造成重复横幅；
      //且原前端推送不判在线，在线用户也会收到与实时消息重复的通知
      return true
    }
    console.warn('IM WebSocket 未连接，消息未发送')
    return false
  },
  //登录认证
  loginIm(accessToken){
    let message = {
      type:"AUTH_REQUEST",
      message:{
        accessToken:accessToken
      }
    }
    this.sendMessage(message)
    this.heartbeat()
  },
  //心跳
  sendHearBeat(){
    let message = {
      type:"HEARTBEAT_REQUEST"
    }
    // console.log("发送心跳")
    this.sendMessage(message)
  },
  //心跳机制
  heartbeat() {
    let that = this
    // 清除之前的心跳计时器
    // console.log("清除开启心跳计时")
    clearTimeout(this.heartbeatTimeout);
    // console.log("开启心跳计时",heartbeatInterval)
    // 设置下一个心跳计时器
    this.heartbeatTimeout = setTimeout(function() {
      // console.log("定时发送")
      that.sendHearBeat();
    }, heartbeatInterval);
  },
  //关闭(主动)：在实例上标记主动关闭(异步 onclose 读到后不重连)，取消挂起的重连定时器与看门狗
  closeIm(){
    console.log(this.im)
    const im = this.im
    if (im) {
      im.__manualClosed = true
    }
    this.stopWatchdog()
    if(reconnectTimeout != null){
      clearTimeout(reconnectTimeout)
      reconnectTimeout = null
    }
    reconnectAttempt = 0
    if(im && im.readyState == 1){
      try { im.close() } catch (e) { /* 忽略关闭异常 */ }
    }
  },


  //业务方法-----------------------------------------------------
  //获取会话列表（全量；登录/重连共用。res.data 为空时写空列表，避免 remake 抛错卡死）
  async getSessions(obj,vuedom){
   let res =  await requestHttpGet(apiUrl+"/admin-api/netty/im/sessions/page",obj)
   console.log(res)
   const sessions = (res && Array.isArray(res.data)) ? res.data : []
   if(obj.type == 'chat'){
    await this.remakeChat(sessions,vuedom)
   }
   if(obj.type == 'group'){
    await this.remakeGroupChat(sessions,vuedom)
   }
  },

  //获取会话信息
  async getSessionsInfo(obj){
    let res =  await requestHttpGet(apiUrl+"/admin-api/netty/im/sessions/get",obj)
    console.log(res)
    return res.data
  },
  //清洗消息体到本地
  async remakeChat(sessions,vuedom){
    let items = []
    for (let index = 0; index < sessions.length; index++) {
      let item = this.normalizeSessionItem(sessions[index]);
      items.push(item)
    }
    console.log(vuedom)
    console.log(items)
    await vuedom.$messageDb.setItem("corlist",this.updateTopSort(items))
  },
  //清洗消息体到本地
  async remakeGroupChat(sessions,vuedom){
    let items = []
    for (let index = 0; index < sessions.length; index++) {
      let item = this.normalizeSessionItem(sessions[index]);
      items.push(item)
    }
    console.log(vuedom)
    console.log(items)
    await vuedom.$messageDb.setItem("grouplist",this.updateTopSort(items))
  },
  //获取单聊会话
  async getlocalChat(vuedom){
    let res  = await vuedom.$messageDb.getItem("corlist")
    console.log(res)
    return res
  },
  async getlocalGroup(vuedom){
    let res  = await vuedom.$messageDb.getItem("grouplist")
    console.log(res)
    return res
  },
  //更新置顶排序
  updateTopSort(list){
    //获取置顶消息
    let newList = []
    let topList = []
    let dopList = []
    let lowList = []
    let dloList = []
    list.forEach(e=>{
      if(e.isTop){
        if(e.message!=null){
          topList.push(e)
        }else{
          dopList.push(e)
        }
      }else{
        if(e.message!=null){
          lowList.push(e)
        }else{
          dloList.push(e)
        }
      }
    })
    //将置顶消息按照最后消息的时间排序
    console.log(list)
    topList.sort((a, b) => b.message.createTime - a.message.createTime);
    lowList.sort((a, b) => b.message.createTime - a.message.createTime);
    dloList.sort((a, b) => b.createTime - a.createTime);
    dopList.sort((a, b) => b.createTime - a.createTime);
    newList.unshift(...dloList)
    newList.unshift(...lowList)
    newList.unshift(...dopList)
    newList.unshift(...topList)
    return newList
  },
  //获取联系热最近联系人列表
  async getRecentContactsList(){
    let res =  await requestHttpGet(apiUrl+"/admin-api/netty/im/sessions/get-recent-contacts",{})
    return res.data
  },
   //获取店铺内所有设计师
   async getShopDesignerList(){
    let res =  await requestHttpGet(apiUrl+"/admin-api/supplier/user/list-all-simple-designer",{})
    return res.data
  },
  //创建群组
  async createGroup(obj){
    await requestHttpPostByOnline(apiUrl+"/admin-api/netty/im/sessions/create-group",obj)
  },
  //离开或者解散群组
  async leaveGroup(obj){
    await requestHttpGet(apiUrl+"/admin-api/netty/im/sessions/leave-group",obj)
  },
  //删除群组成员
  async addGroupUser(obj){
    await requestHttpPostByOnline(apiUrl+"/admin-api/netty/im/sessions/add-group-user",obj)
  },
  //加入群组成员
  async removeGroupUser(obj){
    await requestHttpPostByOnline(apiUrl+"/admin-api/netty/im/sessions/remove-group-user",obj)
  },
  //获取会话消息列表
  async getMessagePage(obj){
    let res =  await requestHttpGet(apiUrl+"/admin-api/netty/im-message/page",obj)
    res.data.list.forEach(e => {
        e.belong = false
        //判断消息是否是自己发出的
        if(e.messageFrom == storage.get('userId')){
          //是自己
          e.belong = true
        }
        e.members.forEach(m=>{
          if(m.id == storage.get('userId')){
              //自己
              e.selfInfo = m
          }else{
              if(m.id == e.messageFrom){
                e.otherInfo = m
              }
          }
        })
        //格式化自定义消息
        console.log(e.messageCustomExt)
        e.messageCustomExt = JSON.parse(e.messageCustomExt)
        this.getMessageTextAndStatus(e)
    });
    return res.data.list
  },
  //获取消息发送者信息
  getMessageMembersInfo(e){
    let info = {}
    e.members.forEach(m=>{
      if(m.id == e.messageFrom){
        info = m
      }
    })
    return info
  },
  //根据会话设置消息已读
  async setMessageIsReadBySessions(obj){
    // /set-read
    return await requestHttpGet(apiUrl+"/admin-api/netty/im-message/set-read",obj)
  },
  //清晰本地消息
  async getChatMessageBody(e){
    if(e.messageFrom == storage.get('userId')){
      //是自己
      e.belong = true
    }
    e.members.forEach(m=>{
      if(m.id == storage.get('userId')){
          //自己
          e.selfInfo = m
      }else{
          if(m.id == e.messageFrom){
            e.otherInfo = m
            //如果是单聊取会话备注替换用户名称
          }
      }
    })
    if(e.messageCustomExt){
      e.messageCustomExt = JSON.parse(e.messageCustomExt)
    }
  
    this.getMessageTextAndStatus(e)
    return e
  },
  async getGroupMessageBody(e){
    if(e.messageFrom == storage.get('userId')){
      //是自己
      e.belong = true
    }
    e.members.forEach(m=>{
      if(m.id == storage.get('userId')){
          //自己
          e.selfInfo = m
      }else{
          if(m.id == e.messageFrom){
            e.otherInfo = m
            //如果是单聊取会话备注替换用户名称
          }
      }
    })
    if(e.messageCustomExt){
      e.messageCustomExt = JSON.parse(e.messageCustomExt)
    }
    this.getMessageTextAndStatus(e)
    return e
  },
  //发送消息已读回执
  sendReadMessage(msgId,userId){
    const msg = {
      type: "CHAT_SEND_TO_READ_BACK_REQUEST",
      message: {
          id:msgId,
          userId:userId,
          accessToken:storage.get('token')
      }
    }
    this.sendMessage(msg)
  },
  async sendForwardImagesMessage(userid, chatType,res,ext,extType) {
		const msg = {
			type: chatType == 'chat' ? "CHAT_SEND_TO_ONE_REQUEST" : "CHAT_SEND_TO_GROUP_REQUEST",
			message: {
				msgId: new Date().getTime(),
				toUser: userid,
				fromUser: storage.get('userId'),
				accessToken: storage.get('token'),
				content: {
					type: chatType,
					attr: "img",
					msg: "图片消息",
					fileUrl: res.messageUrl,
					ext:ext,
					extType:extType,
					customExt: {},
					fileLength: res.messageFileLength,
					fileName: res.messageFileName,
					audioLength: 0,
					imageWidth: 0,
					imageHeight: 0
				}
			}
		}
		console.log(msg)
		this.sendMessage(msg)
	},
	async sendForwardFileMessage(userid, chatType, res,ext,extType) {
		//上传文件到服务器
		const msg = {
			type: chatType == 'chat' ? "CHAT_SEND_TO_ONE_REQUEST" : "CHAT_SEND_TO_GROUP_REQUEST",
			message: {
				msgId: new Date().getTime(),
				toUser: userid,
				fromUser: storage.get('userId'),
				accessToken: storage.get('token'),
				content: {
					type: chatType,
					attr: "file",
					msg: "文件消息",
					fileUrl: res.messageUrl,
					ext: ext,
					extType:extType,
					customExt: {},
					fileLength: res.messageFileLength,
					fileName: res.messageFileName,
					audioLength: 0,
					imageWidth: 0,
					imageHeight: 0
				}
			}
		}
		console.log(msg)
		this.sendMessage(msg)
	},
	async sendForwardVideoMessage(userid, chatType,res,ext,extType) {
		//上传文件到服务器
		const msg = {
			type: chatType == 'chat' ? "CHAT_SEND_TO_ONE_REQUEST" : "CHAT_SEND_TO_GROUP_REQUEST",
			message: {
				msgId: new Date().getTime(),
				toUser: userid,
				fromUser: storage.get('userId'),
				accessToken: storage.get('token'),
				content: {
					type: chatType,
					attr: "video",
					msg: "视频消息",
					fileUrl: res.messageUrl,
					ext: ext,
					extType:extType,
					customExt: {},
					fileLength: res.messageFileLength,
					fileName: res.messageFileName,
					audioLength: 0,
					imageWidth: 0,
					imageHeight: 0
				}
			}
		}
		console.log(msg)
		this.sendMessage(msg)
	},
	async sendForwardAudioMessage(userid, chatType, res,ext,extType) {
		//上传音频到服务器
		const msg = {
			type: chatType == 'chat' ? "CHAT_SEND_TO_ONE_REQUEST" : "CHAT_SEND_TO_GROUP_REQUEST",
			message: {
				msgId: new Date().getTime(),
				toUser: userid,
				fromUser: storage.get('userId'),
				accessToken: storage.get('token'),
				content: {
					type: chatType,
					attr: "audio",
					msg: "语音消息",
					fileUrl: res.messageUrl,
					ext: ext,
					extType:extType,
					customExt: {},
					fileLength: 0,
					fileName: res.messageFileName,
					audioLength: res.messageAudioLength,
					imageWidth: 0,
					imageHeight: 0
				}
			}
		}
		console.log(msg)
		this.sendMessage(msg)
	},
  //发送转发消息方法
	async sendForwardMessage(userid, chatType, textContent, vuedom,ext,extType) {
		if (textContent.match(/^\s*$/)) return
		const msg = {
			type: chatType == 'chat' ? "CHAT_SEND_TO_ONE_REQUEST" : "CHAT_SEND_TO_GROUP_REQUEST",
			message: {
				msgId: new Date().getTime(),
				toUser: userid,
				fromUser: storage.get('userId'),
				accessToken: storage.get('token'),
				content: {
					type: chatType,
					attr: "txt",
					msg: textContent,
					fileUrl: "",
					ext: ext,
					extType:extType,
					customExt: {},
					fileLength: 0,
					fileName: "",
					audioLength: 0,
					imageWidth: 0,
					imageHeight: 0
				}
			}
		}
		console.log(msg)
		this.sendMessage(msg)
	},
  //发送文本消息方法
  async sendTextMessage(userid,chatType,textContent,vuedom,ext,extType){
    const text = textContent == null ? '' : String(textContent).trim()
    if (!text || text.match(/^\s*$/)) return false
    const dedupeKey = `${chatType}|${userid}|${text}`
    const now = Date.now()
    if (dedupeKey === lastTextSendKey && now - lastTextSendAt < 1200) {
      console.warn('sendTextMessage deduped', dedupeKey)
      return true
    }
    lastTextSendKey = dedupeKey
    lastTextSendAt = now
    textContent = text
      //获取当前用户出图时间
      let designer = await requestHttpGet(apiUrl+'/admin-api/supplier/user/get-designer-pc-im')
      if(designer.data != null){
        if(textContent.includes("{outpic}")){
          console.log(designer.data.designer.acceptanceDate.join("-"))
          const regex = new RegExp("{outpic}", 'g');
          textContent = textContent.replace(regex, designer.data.designer.acceptanceDate.join("-"));
        }
      }
      const msg = {
        type: chatType =='chat'?"CHAT_SEND_TO_ONE_REQUEST":"CHAT_SEND_TO_GROUP_REQUEST",
        message: {
            msgId:`${now}_${Math.random().toString(36).slice(2, 9)}`,
            toUser:userid,
            fromUser:storage.get('userId'),
            accessToken:storage.get('token'),
            content: {
                type: chatType,
                attr: "txt",
                msg: textContent,
                fileUrl: "",
                ext: ext,
                extType:extType,
                customExt:{},
                fileLength:0,
                fileName:"",
                audioLength:0,
                imageWidth:0,
                imageHeight:0
            }
        }
      }
      return this.sendMessage(msg)
  },
  //发送自定义消息
  async sendCustomMessages(userid,chatType,objCustom,vuedom,ext,extType){
    if (!this.isImConnected()) {
      return false
    }
    const msg = {
      type: chatType =='chat'?"CHAT_SEND_TO_ONE_REQUEST":"CHAT_SEND_TO_GROUP_REQUEST",
      message: {
          msgId:`${Date.now()}_${Math.random().toString(36).slice(2, 9)}`,
          toUser:userid,
          fromUser:storage.get('userId'),
          accessToken:storage.get('token'),
          content: {
              type: chatType,
              attr: "custom",
              msg: "订单消息",
              fileUrl: "",
              ext: ext,
              extType:extType,
              customExt:objCustom,
              fileLength:0,
              fileName:"",
              audioLength:0,
              imageWidth:0,
              imageHeight:0
          }
      }
    }
    return this.sendMessage(msg)
  },
  async sendImagesMessage(userid,chatType,fileInfo,ext,extType){
    //上传图片到服务器
    console.log(fileInfo)
    let obj = {
      file:fileInfo,
      path:new Date().getTime()
    }
    let res = await requestHttpUpload(apiUrl+"/admin-api/infra/file/upload",obj)
    if(!res || !res.data){
      //上传失败(超时/413/网络中断)：终止发送，避免把失败响应当文件地址发出去
      return
    }
    const msg = {
      type: chatType =='chat'?"CHAT_SEND_TO_ONE_REQUEST":"CHAT_SEND_TO_GROUP_REQUEST",
      message: {
          msgId:new Date().getTime(),
          toUser:userid,
          fromUser:storage.get('userId'),
          accessToken:storage.get('token'),
          content: {
              type: chatType,
              attr: "img",
              msg: "图片消息",
              fileUrl: res.data,
              ext: ext,
              customExt:{},
              extType:extType,
              fileLength:fileInfo.size,
              fileName:fileInfo.name,
              audioLength:0,
              imageWidth:0,
              imageHeight:0
          }
      }
    }
    console.log(msg)
    this.sendMessage(msg)
  },
  async sendFileMessage(userid,chatType,fileInfo,ext,extType){
    //上传文件到服务器
    console.log(fileInfo)
    let obj = {
      file:fileInfo,
      // path:new Date().getTime()
    }
    let res = await requestHttpUpload(apiUrl+"/admin-api/infra/file/upload",obj)
    if(!res || !res.data){
      //上传失败(超时/413/网络中断)：终止发送，避免把失败响应当文件地址发出去
      return
    }
    const msg = {
      type: chatType =='chat'?"CHAT_SEND_TO_ONE_REQUEST":"CHAT_SEND_TO_GROUP_REQUEST",
      message: {
          msgId:new Date().getTime(),
          toUser:userid,
          fromUser:storage.get('userId'),
          accessToken:storage.get('token'),
          content: {
              type: chatType,
              attr: "file",
              msg: "文件消息",
              fileUrl: res.data,
              ext: ext,
              extType:extType,
              customExt:{},
              fileLength:fileInfo.size,
              fileName:fileInfo.name,
              audioLength:0,
              imageWidth:0,
              imageHeight:0
          }
      }
    }
    console.log(msg)
    this.sendMessage(msg)
  },
  async sendVideoMessage(userid,chatType,fileInfo,ext,extType){
    //上传文件到服务器
    console.log(fileInfo)
    let obj = {
      file:fileInfo,
      path:new Date().getTime()
    }
    let res = await requestHttpUpload(apiUrl+"/admin-api/infra/file/upload",obj)
    if(!res || !res.data){
      //上传失败(超时/413/网络中断)：终止发送，避免把失败响应当文件地址发出去
      return
    }
    const msg = {
      type: chatType =='chat'?"CHAT_SEND_TO_ONE_REQUEST":"CHAT_SEND_TO_GROUP_REQUEST",
      message: {
          msgId:new Date().getTime(),
          toUser:userid,
          fromUser:storage.get('userId'),
          accessToken:storage.get('token'),
          content: {
              type: chatType,
              attr: "video",
              msg: "视频消息",
              fileUrl: res.data,
              ext: ext,
              extType:extType,
              customExt:{},
              fileLength:fileInfo.size,
              fileName:fileInfo.name,
              audioLength:0,
              imageWidth:0,
              imageHeight:0
          }
      }
    }
    console.log(msg)
    this.sendMessage(msg)
  },
  async sendAudioMessage(userid,chatType,fileInfo,ext,extType){
    //上传音频到服务器
    console.log(fileInfo)
    let fileOfBlob = new File([fileInfo.src], new Date().getTime() + '.mp3')
    console.log(fileOfBlob)
    let obj = {
      file:fileOfBlob,
      path:new Date().getTime()
    }
    let res = await requestHttpUpload(apiUrl+"/admin-api/infra/file/upload",obj)
    if(!res || !res.data){
      //上传失败：终止发送(requestHttpUpload 的 catch 已 toast 网络失败；这里补后端返回空数据的提示)
      message.error('语音文件上传失败，语音消息未发送')
      return
    }
    const msg = {
      type: chatType =='chat'?"CHAT_SEND_TO_ONE_REQUEST":"CHAT_SEND_TO_GROUP_REQUEST",
      message: {
          msgId:new Date().getTime(),
          toUser:userid,
          fromUser:storage.get('userId'),
          accessToken:storage.get('token'),
          content: {
              type: chatType,
              attr: "audio",
              msg: "语音消息",
              fileUrl: res.data,
              ext: ext,
              extType:extType,
              customExt:{},
              fileLength:0,
              fileName:fileOfBlob.name,
              audioLength:fileInfo.length,
              imageWidth:0,
              imageHeight:0
          }
      }
    }
    console.log(msg)
    this.sendMessage(msg)
  },
  




  //获取提示文字及状态
  getMessageTextAndStatus(e){
    if(e.messageType != 'custom'){
      return 
    }
    if(e.messageCustomExt.type == "selectOrder"){
      //结算单消息
      e.messageCustomExt.actionType = "亲，已帮您选择好商品规格，喜欢的话可点击“立即接单”完成下单"
      e.messageCustomExt.type = "selectOrder"
      return 
    }
    if(e.messageCustomExt.type == 'designerProduct'){
      e.messageCustomExt.actionType = ""
      e.messageCustomExt.actionNo = ""
      e.messageCustomExt.actionName = "查看详情"
      return 
    }
    if(e.messageCustomExt.type == 'renderProduct'){
      e.messageCustomExt.actionType = ""
      e.messageCustomExt.actionNo = ""
      e.messageCustomExt.actionName = "查看详情"
      return 
    }
    e.messageCustomExt.actionNo = e.messageCustomExt.no
    e.messageCustomExt.actionName = this.getOrderButtonName(e.messageCustomExt)
    e.messageCustomExt.actionStatus = true
  },
  getOrderButtonName(e){
    let res = ""
    if(e.refundStatus!=0){
      switch (e.refundStatus) {
        case 10:
          res = "部分退款完成"
          break;
        case 20:
          res = "全部退款完成"
          break;
        default:
          res = "退款中"
      }
      return res
    }
    switch (e.status) {
      case 0:
        res = "待支付"
        break;
      case 10:
        res = "对接中"
        break;
      case 20:
        res = "待确认需求"
        break;
      case 30:
        res = "制图中"
        break;
      case 40:
        res = "待确认效果图"
        break;
      case 41:
        res = "待审核效果图"
        break;
      case 50:
        res = "已完成"
        break;
      case 60:
        res = "待确认改图需求"
        break;
      case 70:
        res = "改图制图中"
        break;
      case 100:
        res = "已关闭"
        break;
      default:
        res = "申请退款"
    }
    return res
  },
  //离线消息
  async sendPushMsg(message){
    console.log("发送离线")
    console.log(message)
    if(message.content.type == "group"){
      let nickname = ""
      let avatar = ""
      let pushArr = []
      let content = message.content.msg
      let res = await requestHttpGet(apiUrl+"/admin-api/netty/im/sessions/get-group-member-info",{id:message.toUser})
      if(res.data!=null){
        res.data.forEach(e=>{
          if(message.fromUser == e.id){
            nickname = e.nickname
            avatar = e.avatar
          }else{
            pushArr.push(e.id)
          }
        })
      }
      if(pushArr.length>0){
        let obja = {
          getui_alias: pushArr, //接收人
          title:nickname+"在群组向您发送了一条新消息。",
          content:content,
          payload:{"type":4,"orderId":message.toUser,chatType:'group',nickname:nickname,avatarurl:avatar},
          request_id:new Date().getTime()+"s"
        }
        console.log(obja)
        let ras = await requestHttpPostByOnline('https://fc-mp-d9355a6b-424f-47cc-b10b-4865ae8b23a6.next.bspapp.com/sysPushForUserId', obja)
        console.log(ras)
      }
    }else{
      let nickname = ""
      let avatar = ""
      let pushArr = []
      let content = message.content.msg
      let res = await requestHttpGet(apiUrl+"/admin-api/netty/im/sessions/get-member-info",{ids:message.toUser+","+message.fromUser})
      if(res.data!=null){
        res.data.forEach(e=>{
          if(message.fromUser == e.id){
            nickname = e.nickname
            avatar = e.avatar
          }else{
            pushArr.push(e.id)
          }
        })
      }
      if(pushArr.length>0){
        let obja = {
          getui_alias: pushArr, //发送人
          title:nickname+"向您发送了一条新消息。",
          content:content,
          payload:{"type":1,"orderId":message.toUser,chat:'chat',nickname:nickname,avatarurl:avatar},
          request_id:new Date().getTime()+"s"
        }
        console.log(obja)
        let ras = await requestHttpPostByOnline('https://fc-mp-d9355a6b-424f-47cc-b10b-4865ae8b23a6.next.bspapp.com/sysPushForUserId', obja)
        console.log(ras)
      }
       
      //获取用户是否在线
        // console.log(uid,"调用离线通知~") 
        // console.log(uid,message)
        // //发送人头像
        // //发送人user_name
        // let nickname = storage.get('UserName')
        // let avatarurl = storage.get('UserHeader')
        // let contentz = "您有新的聊天信息啦,请注意查收"
        // if (message.type == "txt") {
        //   if(message.msg.length > 40){
        //     contentz = message.msg.substr(0,35)+"..."
        //   }else{
        //     contentz = message.msg
        //   }
        // }
        // if (message.type == "txt") {
        //   if(message.msg.indexOf('[') >= 0){
        //     contentz = "[表情]"
        //   }
        // }
        // if (message.type == "img") {
        //   contentz = "[图片]"
        // }
        // if (message.type == "file") {
        //   contentz = "[文件]"
        // }
        // if (message.type == "audio") {
        //   contentz = "[语音]"
        // }
        // if (message.type == "video") {
        //   contentz = "[视频]"
        // }
        // if (message.type == "custom") {
        //   contentz = "[链接]"
        // }
        // if(uid){
        //   let muid = ""
        //   if(uid.indexOf("im")>=0){
        //     muid = uid.split("im")[1]
        //   }else{
        //     muid = uid.split("bk")[1]
        //   }
        //   let obja = {
        //     getui_alias: muid, //发送人
        //     title:nickname+"向您发送了一条新消息。",
        //     content:contentz,
        //     payload:{"type":1,"orderId":muid,chatType:message.chatType,nickname:nickname,avatarurl:avatarurl},
        //     request_id:new Date().getTime()+"s"
        //   }
        //   console.log(obja)
        //   if(muid!=""){
        //     let ras = await requestHttpPostByOnline('https://fc-mp-d9355a6b-424f-47cc-b10b-4865ae8b23a6.next.bspapp.com/sysPushForUserId', obja)
        //     console.log(ras)
        //   }
        // }
    }
    
  },
}